import axios from 'axios';
import { BACKEND_URL } from "../backendURL";


class RegionalsService {

    geRegionalData(token) {
        const config = {
            headers: {
                'Authorization': "Token " + token
            },

        };
        let request_url = BACKEND_URL + "/api/division/regional-data/";
        return axios.get(request_url, config);
    };

}


export default new RegionalsService();